<template lang="pug">
#main-contents
    //- あとでけす
    //- .range
    //-     input(type="range" min="0" max="100" v-model="range")
    .gallery
        a.link(href="https://renodeluxe.jp/gallery/")
            img.img(src="@/assets/img/gallery_icon.svg")

    photo-img.observe.item.item01(
        :photo="photodata['01']",
        :isPlay="photos.item01"
    )
    .item.item_textfirst
        img.pc(
            src="@/assets/img/text/2.svg",
            alt="リュクスとは、贅沢・豪華・高価で上品なことだけをさすのではなく、「自分が本当に気に入ったものを手にすることこそが真の贅沢である」という概念"
        )
        img.sp(
            src="@/assets/img/text/sp2.svg",
            alt="リュクスとは、贅沢・豪華・高価で上品なことだけをさすのではなく、「自分が本当に気に入ったものを手にすることこそが真の贅沢である」という概念"
        )
    photo-img.observe.item.item03(
        :photo="photodata['02']",
        :isPlay="photos.item02"
    )
    .item.item04
        .first
            photo-img.observe.box.left.-height(
                :photo="photodata['03']",
                :isPlay="photos.item03"
            )
            .box.right
                .text
                    img.catch.pc(
                        src="@/assets/img/text/3.svg",
                        alt="日常を特別にしてくれるリュクスなインテリア おしゃれを楽しむようにインテリアにもこだわりを"
                    )
                    img.catch.sp(
                        src="@/assets/img/text/sp3.svg",
                        alt="日常を特別にしてくれるリュクスなインテリア おしゃれを楽しむようにインテリアにもこだわりを"
                    )
                    //- img.leaf(src="@/assets/img/leaf01.png")
                photo-img.observe.img.observe03(
                    :photo="photodata['04']",
                    :isPlay="photos.item04"
                )
        .second
            .left
                img.catch.pc(
                    src="@/assets/img/text/4.svg",
                    alt="上質な素材・質感・色彩に自分らしくこだわり心地よい空間に包まれる幸せ"
                )
                img.catch.sp(
                    src="@/assets/img/text/sp4.svg",
                    alt="上質な素材・質感・色彩に自分らしくこだわり心地よい空間に包まれる幸せ"
                )
                //- img.leaf(src="@/assets/img/leaf02.png")
            photo-img.observe.box.right(
                :photo="photodata['05']",
                :isPlay="photos.item05"
            )
    photo-img.observe.item.item05(
        :photo="photodata['06']",
        :isPlay="photos.item06"
    )
    .item.item06
        img.pc(
            src="@/assets/img/text/5.svg",
            alt="妥協せずずっと輝く自分でいたい あなたのリュクスな暮らしのヒントに"
        )
        img.sp(
            src="@/assets/img/text/sp5.svg",
            alt="妥協せずずっと輝く自分でいたい あなたのリュクスな暮らしのヒントに"
        )
    .item.item_footFlower
        img(src="@/assets/img/11.png")
</template>
<style lang="scss" scoped>
#main-contents {
  @include container;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  > .gallery {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 60px;
    margin-bottom: 60px;
    background: #fff;
    border-radius: 150px;
    width: 130px;
    height: 130px;
    @include shadow;
    > .link {
      > .img {
        width: 70px;
      }
    }
  }

  > .item {
    padding: 16px 0;
    width: 100%;
    @media #{$pc} {
      padding: 32px 0;
    }
  }

  > .item_textfirst {
    padding-bottom: 32px;
    @media #{$tab} and (-ms-high-contrast: none) {
      height: 92px;
    }
    @media #{$pc} {
      margin-left: 280px;
      width: 445px;
      @media (-ms-high-contrast: none) {
        height: 126px;
      }
    }
  }

  > .item_textfirst {
    > .pc {
      display: none;
      @media #{$pc} {
        display: block;
        width: 445px;
      }
    }

    > .sp {
      display: block;
      width: 290px;
      margin: 0 auto;
      @media #{$pc} {
        display: none;
      }
    }
  }

  > .item04 {
    > .first {
      display: flex;
      flex-direction: column-reverse;
      @media #{$pc} {
        flex-direction: row;
        justify-content: flex-end;
        padding-bottom: 48px;
      }

      > .box {
        @media #{$pc} {
          margin: 0 16px;
        }
      }

      > .left {
        @media #{$pc} {
          padding-top: 64px;
        }
      }

      > .right {
        @media #{$pc} {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
      }

      > .right > .text {
        display: flex;
        justify-content: space-around;
        align-items: flex-end;
        padding-bottom: 24px;
        @media #{$pc} {
          padding-bottom: 0;
        }

        > .catch {
          width: 285px;
          @media #{$pc} {
            width: 346px;
            padding-bottom: 48px;
          }

          &.pc {
            display: none;
            @media #{$pc} {
              display: block;
              margin-right: 115px;
            }
          }

          &.sp {
            display: block;
            @media #{$pc} {
              display: none;
            }
          }
        }

        > .leaf {
          @media #{$pc} {
            width: 158px;
            height: 125px;
          }
          width: 30%;
        }
      }

      > .right > .img {
        padding: 16px 0;
        @media #{$pc} {
          padding-bottom: 64px;
        }
      }
    }

    > .second {
      @media #{$pc} {
        display: flex;
        justify-content: space-between;
      }

      > .left {
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        justify-content: space-around;
        padding-top: 16px;
        padding-bottom: 28px;

        @media #{$pc} {
          flex-direction: row;
          margin: 0 auto;
          padding-top: 0;
          padding-bottom: 0;
        }
        > .catch {
          width: 180px;
          @media #{$pc} {
            width: 205px;
            padding-bottom: 128px;
          }

          &.pc {
            display: none;
            @media #{$pc} {
              display: block;
            }
          }

          &.sp {
            display: block;
            margin-right: 30%;
            @media #{$pc} {
              display: none;
            }
          }
        }
        > .leaf {
          width: 28%;
          height: 100%;
          @media #{$pc} {
            width: 185px;
            height: 123px;
            padding-bottom: 16px;
          }
        }
      }

      > .right {
        padding-top: 16px;

        @media #{$pc} {
          padding-top: 0;
          padding-bottom: 0;
        }
      }
    }
  }

  > .item05 {
    @media #{$pc} {
      margin: 0 auto;
      padding-top: 64px;
    }
  }

  > .item06 {
    @media all and (-ms-high-contrast: none) {
      height: 100px;
    }
    > img {
      @media #{$pc} {
        width: 100%;
        @media all and (-ms-high-contrast: none) {
          height: 50px;
        }
      }
    }

    > .pc {
      display: none;
      @media #{$pc} {
        display: block;
        width: 259px;
        margin: 0 auto;
      }
    }

    > .sp {
      display: block;
      width: 230px;
      margin-left: 40px;
      @media #{$pc} {
        display: none;
      }
    }
  }

  > .item_footFlower {
    width: 100%;
    @media #{$pc} {
      width: 780px;
      margin: 0 auto;
    }
    > img {
      width: 100%;
    }
  }
}
</style>
<script>
// json
import photoData from '@/assets/photo';
// components
import photoImg from '@/components/photo-img';
export default {
  components: {
    photoImg,
  },
  data() {
    return {
      photodata: photoData,
      photos: {
        item01: false,
        item02: false,
        item03: false,
        item04: false,
        item05: false,
        item06: false,
      },
    };
  },
  computed: {},
  methods: {},
  mounted() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const className = entry.target.className;
          if (className.indexOf('item01') !== -1) {
            this.photos.item01 = true;
          }
          if (className.indexOf('item03') !== -1) {
            this.photos.item02 = true;
          }
          if (className.indexOf('left') !== -1) {
            this.photos.item03 = true;
          }
          if (className.indexOf('observe03') !== -1) {
            this.photos.item04 = true;
          }
          if (className.indexOf('right') !== -1) {
            this.photos.item05 = true;
          }
          if (className.indexOf('item05') !== -1) {
            this.photos.item06 = true;
          }
        }
      });
    }, {});
    const targets = document.querySelectorAll('.observe');
    targets.forEach(function(target) {
      // 監視の開始
      observer.observe(target);
    });
  },
  watch: {},
};
</script>
